import React, { useMemo } from "react";
import TwemojiWrapper from "../../../../components/TwemojiWrapper/TwemojiWrapper";

interface Props {
  image?: string;
}

export default function (props: Props) {
  const isCustom = useMemo(() => {
    return props.image?.includes(".");
  }, [props.image]);

  const CONTENT = useMemo(() => {
    if (isCustom) {
      return (
        <div
          className="d-flex justify-content-center align-items-center border"
          style={{
            borderRadius: 6,
            minWidth: 80,
            width: 80,
            maxWidth: 80,
            minHeight: 80,
            height: 80,
            maxHeight: 80
          }}
        >
          <img
            data-twic-src={`image:/cdm/jetpack/gifts/${props.image}`}
            data-src-transform={"cover=WxH/quality=100"}
            style={{
              minWidth: 80,
              width: 80,
              maxWidth: 80,
              minHeight: 80,
              height: 80,
              maxHeight: 80
            }}
          />
        </div>
      );
    }
    return (
      <div
        className="d-flex justify-content-center align-items-center border"
        style={{
          borderRadius: 6,
          width: 80,
          height: 80,
          fontSize: 56,
          padding: 16
        }}
      >
        <TwemojiWrapper isBigText={true}>{props.image}</TwemojiWrapper>
      </div>
    );
  }, [props.image, isCustom]);

  return CONTENT;
}
